import { ADDINS_CHANGE_SOURCE } from '../constants';
import { EditorViewState, lazyOperateContent } from 'owa-editor';
import { CompositeEditorViewState } from 'owa-editor/lib/store/schema/CompositeEditorViewState';
import { ContentPosition } from 'roosterjs-editor-types';

export default function prependContentToEditor(viewState: EditorViewState, content: string) {
    return lazyOperateContent.import().then(operateContent => {
        operateContent(
            viewState as CompositeEditorViewState,
            (htmlEditor, originalRange, domApi) => {
                const doc = htmlEditor.getDocument();
                const nodes = domApi.fromHtml(content, doc);
                const fragment = doc.createDocumentFragment();
                nodes.forEach(node => fragment.appendChild(node));

                htmlEditor.focus();
                htmlEditor.insertNode(fragment, {
                    position: ContentPosition.Begin,
                    updateCursor: false,
                    replaceSelection: false,
                    insertOnNewLine: false,
                });

                return {
                    selectionRange: originalRange,
                    changeSource: ADDINS_CHANGE_SOURCE,
                };
            },
            (value, selectionStart, selectionEnd) => {
                return {
                    value: content + value,
                    selectionStart: selectionStart,
                    selectionEnd: selectionEnd,
                    focus: true,
                };
            }
        );
    });
}
